module.exports = __webpack_public_path__ + "img/Enkele_plooi_retour.d8150466.png";